import React, {useState} from "react";
import {sendFriendRequest} from "../clients/FriendClient";
import Icon from "./ui/Icon";

// Inline "add a friend by username" form
const SendFriendRequestModal = ({successCallback}) => {
    const [friendRequestName, setFriendRequestName] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)
    const [sending, setSending] = useState(false)

    const sendFriendInvite = (event) => {
        event.preventDefault();
        const name = friendRequestName.trim();
        if (!name) return;
        setSending(true);
        sendFriendRequest(name)
            .then(() => {
                setErrorMessage(null);
                setFriendRequestName("");
                successCallback && successCallback(name);
            })
            .catch((e) => setErrorMessage(e.response?.data?.message || e.message))
            .finally(() => setSending(false));
    }

    return (
        <form className="stack stack--sm" onSubmit={sendFriendInvite}>
            <div className="add-friend-form">
                <input className="input" value={friendRequestName} autoFocus
                       placeholder="Username"
                       aria-label="Username of your friend"
                       onChange={(e) => {
                           setFriendRequestName(e.target.value);
                           setErrorMessage(null);
                       }}/>
                <button type="submit" className="btn btn-primary btn-sm" disabled={!friendRequestName.trim() || sending}>
                    {sending ? <span className="spinner spinner--sm spinner--light"/> : <Icon name="send"/>} Send
                </button>
            </div>
            {errorMessage && <div className="form-error">{errorMessage}</div>}
        </form>
    )
}

export default SendFriendRequestModal;
